module.exports = __webpack_public_path__ + "media/site/images/products/ekanban-screen-dd5088225b89784dc7295e55046f385e.png";